<template>
  <v-dialog
    :content-class="dialogClass"
    persistent
    scrollable
    :max-width="maxWidth"
    :value="show"
    :fullscreen="fullscreen"
    @input="$emit('input', $event)"
  >
    <v-card class="card-rounded dialog-content">
      <template v-if="!loading">
        <v-card-title v-if="(hasHeaderSlot || title) && closable">
          <div class="dialog-header">
            <slot name="header" v-if="hasHeaderSlot"></slot>
            <h3 v-else>{{ title }}</h3>
          </div>
          <div v-if="showCloseButton" class="dialog-close">
            <v-btn icon @click="close">
              <v-icon size="24">icon-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-title v-else>
          <slot name="header" v-if="hasHeaderSlot"></slot>
          <h3 class="text-center w-100" v-else>{{ title }}</h3>
        </v-card-title>
        <v-card-text>
          <slot></slot>
        </v-card-text>
        <v-card-actions v-if="hasActionsSlot">
          <div class="dialog-actions">
            <slot name="actions"></slot>
          </div>
        </v-card-actions>
      </template>
      <template v-else>
        <v-card-text class="dialog-loader">
          <SectionLoader :status="loading" :opacity="1" />
        </v-card-text>
      </template>
      <slot name="loader"></slot>
    </v-card>
  </v-dialog>
</template>

<script>
import SectionLoader from "@/components/Loader/SectionLoader";

export default {
  name: "UiDialog",
  components: {
    SectionLoader
  },
  model: {
    prop: "show",
    event: "input"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: String,
    closable: {
      type: Boolean,
      default: true
    },
    maxWidth: {
      type: String,
      default: "620px"
    },
    customClass: String,
    loading: {
      type: Boolean,
      default: false
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasHeaderSlot() {
      return !!this.$slots["header"];
    },
    hasActionsSlot() {
      return !!this.$slots["actions"];
    },
    dialogClass() {
      let classes = ["custom-dialog"];

      if (this.customClass) {
        classes.push(this.customClass);
      }

      return classes.join(" ");
    }
  },
  methods: {
    close() {
      this.$emit("input", false);
    }
  }
};
</script>
